<template>
  <div class="metadata-section" data-testid="metadata-section">
    <div v-if="collectionCurrentItem" class="mb-1">
      <MetaButton tooltip="Show collection" data-testid="viewer-button-collection-name" tooltip-placement="top-start" :href="collectionCurrentItem.url">
        <Icon name="general.folder" size="sm" />
        <span>{{ collectionCurrentItem.name }}</span>
      </MetaButton>
    </div>

    <div class="metadata-section__toolbar">
      <template v-if="showToolbar && isCurrentItemOwner">
        <ButtonExpires />
        <ButtonViews />
        <ButtonCreatedAt v-if="showCreatedAt" />
        <ButtonDuration v-if="showDuration" />
        <span v-if="hasRequestContent" class="text-slate-200 dark:text-zinc-700">|</span>
      </template>
      <TranslationSelector v-if="showTranslation" />
      <RequestContentInfo />
    </div>

    <!-- Non-hoverable Call to Action (shown below content when configured) -->
    <div v-if="!isHoverable && displayActionActive" class="mt-2">
      <CallToAction :hoverOnly="false" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { Icon } from '@/storybook';

import MetaButton from '@/modules/viewer/components/MetaButton.vue';
import ButtonExpires from '@/modules/viewer/components/meta_buttons/ButtonExpires.vue';
import ButtonViews from '@/modules/viewer/components/meta_buttons/ButtonViews.vue';
import ButtonCreatedAt from '@/modules/viewer/components/meta_buttons/ButtonCreatedAt.vue';
import ButtonDuration from '@/modules/viewer/components/meta_buttons/ButtonDuration.vue';
import RequestContentInfo from '@/modules/viewer/components/RequestContentInfo.vue';
import TranslationSelector from '@/modules/viewer/components/translations/TranslationSelector.vue';
import CallToAction from '@/modules/viewer/components/CallToAction.vue';

import { useViewerItemStore } from '@/modules/viewer/store/useViewerItemStore';
import { useCallToActionStore } from '@/modules/viewer/store/useCallToActionStore';
import { useUser } from '@/modules/viewer/composables/useUser';

withDefaults(
  defineProps<{
    showToolbar?: boolean;
    showCreatedAt?: boolean;
    showDuration?: boolean;
    showTranslation?: boolean;
  }>(),
  {
    showToolbar: true,
    showCreatedAt: false,
    showDuration: false,
    showTranslation: true,
  }
);

const store = useViewerItemStore();
const { collectionCurrentItem, hasRequestContentResponse: hasRequestContent } = storeToRefs(store);
const { isCurrentItemOwner } = useUser();
const { isHoverable, displayActionActive } = storeToRefs(useCallToActionStore());
</script>

<style scoped>
.metadata-section {
  @apply mt-1;
}

.metadata-section__toolbar {
  @apply mt-0.5 flex flex-wrap gap-x-2 gap-y-1 sm:gap-x-4 justify-start items-center text-xs sm:text-sm dark:text-zinc-300;
}
</style>
